import { Leaf7DataStruct } from './types'
import sm2 from './smCrypto/sm2'
import sm3 from './smCrypto/sm3'
import sm4 from './smCrypto/sm4'

import { Leaf7EncryptOptions } from './types'

import readBlob from '../utils/readBlob'

import type ErrorHandlerChain from '../ErrorHandlerChain'
import ResponseError404 from '../error/ResponseError404'
import ResponseError500 from '../error/ResponseError500'
import ResponseErrorException from '../error/ResponseErrorException'
import ResponseError from '../error/ResponseError'
import ResponseErrorSessionException from '../error/ResponseErrorSessionException'
import ResponseError403 from '../error/ResponseError403'

export default class Leaf7ErrorHandler {
  options: Leaf7EncryptOptions
  constructor(options: Leaf7EncryptOptions) {
    this.options = options
  }

  async handle(error: Error, chain: ErrorHandlerChain) {
    const { _s1, _s2 } = this.options
    if (error.response) {
      const response = error.response
      const errortext = `'${response.config.url}' ${response.status} ${response.statusText}`
      if (response.status == 200) {
        const rawData = response.data
        // 取header中的签名
        let signature = response.headers['web-encrypt-sign']
        let timestamp = response.headers['web-encrypt-timestamp']

        let jsonData

        if (rawData instanceof Blob) {
          // 文件下载抛异常JSON，在Blob里面
          if (rawData != null && signature) {
            const tempData = await readBlob(rawData)
            let verifySignatureResult: boolean
            signature = signature

            const mergeStr = timestamp + tempData
            const sm3Str = sm3(mergeStr)
            // 验签
            try {
              verifySignatureResult = sm2._s2DOVERSIG(sm3Str, signature, _s2, { hash: true, der: true })
            } catch (e) {
              throw new Error('电子签名验证失败，接收到的响应无效')
            }
            if (!verifySignatureResult) {
              throw new Error('电子签名验证失败，接收到的响应无效')
            }

            const result = JSON.parse(sm4._s4DE(tempData, _s1))
            jsonData = result
          } else {
            jsonData = await readBlob(rawData)
            jsonData = JSON.parse(jsonData)
          }
        } else {
          // 普通请求的异常JSON
          jsonData = rawData
        }

        const { appcode, msg }: Leaf7DataStruct = jsonData

        if (appcode != '0') {
          throw new ResponseErrorException(msg, error, response, jsonData)
        }
      } else if (response.status == 401) {
        throw new ResponseErrorSessionException(errortext, error, response)
      } else if (response.status == 403) {
        throw new ResponseError403(errortext, error, response)
      } else if (response.status == 404) {
        throw new ResponseError404(errortext, error, response)
      } else if (response.status == 500) {
        throw new ResponseError500(errortext, error, response)
      } else {
        throw new Error(errortext)
      }
    }

    throw error
  }
}
